import firebase from "firebase";
const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyAQ9EJrQ-I2rkHFa2tGzV6FD-8J2BLHbiw",
    authDomain: "clone-19351.firebaseapp.com",
    databaseURL: "https://clone-19351.firebaseio.com",
    projectId: "clone-19351",
    storageBucket: "clone-19351.appspot.com",
    messagingSenderId: "367820516148",
    appId: "1:367820516148:web:8842e6b52b98de53695361",
    measurementId: "G-REPZLT9EQ4"
});

const db = firebaseApp.firestore();
const auth = firebase.auth();
export {db,auth};